<template>
  <div class="information">
    <div class="information__wrapper">
      <div class="information__logo">
        <r-logo />
      </div>
      <div class="information__content">
        <div class="information__title">
          <r-title type="title-1">RITM</r-title>
        </div>

        <div class="information__subtitle">
          <r-text> {{ $t("information:subtitle") }} </r-text>
        </div>
        <div class="information__privacy">
          <a
            href="https://ritm3.ru/confidential"
            class="r-link"
            target="_blank"
          >
            {{ $t("information:privacy") }}
          </a>
        </div>
        <div class="information__footer">
          <r-text>
            {{ $t("information:footer-apluss") }}
          </r-text>
          <r-text type="caption">
            {{ $t("information:footer-simetra") }}
          </r-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.information {
  margin-top: -15px;
  &__wrapper,
  &__content,
  &__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__logo {
    height: 90px;
    width: 76px;
    margin-bottom: 16px;
  }
  &__title {
    margin-bottom: 4px;
    text-align: center;
  }
  &__privacy {
    margin: 16px;

    .r-link {
      font-size: 11px !important;
    }
  }
  &__footer {
    .r-text.caption-2 {
      margin-top: 4px;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "information:subtitle": "Версия: 0.9 - Talpa",
    "information:privacy": "Политика конфиденциальности",
    "information:footer-apluss": "© 2019 ООО «А+С Транспроект»",
    "information:footer-simetra": "Powered by Simetra®"
  },
  "en": {
    "information:subtitle": "Version: 0.9 - Talpa",
    "information:privacy": "Privacy policy",
    "information:footer-apluss": "© 2019 ООО «А+С Транспроект»",
    "information:footer-simetra": "Powered by Simetra®"
  }
}
</i18n>
